import { useEffect, useState } from "react";

import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
} from "@material-ui/core";

import credentialsService from "../../domain/services/credentials.service";
import loginService from "../../domain/services/login.service";
import faciliterProfileNewsService from "../../domain/services/correspondent/faciliter.profile.news.service";
import ContactChannelsVerifier from "./contact.channels.verifier.component";

const FaciliterCredentialsVerificationModal = ({ setAlert, onClose, onDismiss, blocking = false }) => {

    const [open, setOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [allVerified, setAllVerified] = useState(false);

    const closeModal = () => {
        setOpen(false);
        onClose();
    };

    const dismissModal = () => {
        setOpen(false);
        if (onDismiss) onDismiss();
    };

    const clearFlagAndClose = () => {
        loginService.refreshUserAuthentication((currentUser) => ({
            ...currentUser,
            faciliter: { ...currentUser.faciliter, needToVerifyChannels: false },
        }));
        closeModal();
    };

    useEffect(() => {
        (async () => {
            const currentUser = loginService.getUserAuthentication();

            if (!currentUser?.faciliter?.needToVerifyChannels) {
                closeModal();
                return;
            }

            if (!blocking && faciliterProfileNewsService.wasPlatformNewsShownInSession()) {
                closeModal();
                return;
            }

            setUser(currentUser);

            const data = await credentialsService.getStatus().then((result) => result.data).catch(() => null);
            if (data?.allVerified) {
                clearFlagAndClose();
                return;
            }

            setOpen(true);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog
            disableBackdropClick={blocking}
            disableEscapeKeyDown={blocking}
            onClose={blocking ? undefined : dismissModal}
            fullWidth maxWidth="sm" open={open}
        >
            <DialogTitle>
                <Typography variant="h3">Verifique seus dados</Typography>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" style={{ marginBottom: 16 }}>
                    Para receber e atender solicitações, confirme seu WhatsApp e e-mail. Enviaremos um código para cada canal.
                </Typography>
                {open && (
                    <ContactChannelsVerifier
                        setAlert={setAlert}
                        onAllVerifiedChange={setAllVerified}
                        contactFallback={user}
                    />
                )}
            </DialogContent>
            <DialogActions style={{ padding: '8px 24px 16px', justifyContent: 'space-between' }}>
                {!blocking
                    ? <Button onClick={dismissModal}>Verificar depois</Button>
                    : <span />}
                <Button
                    variant="contained" color="primary"
                    disabled={!allVerified}
                    onClick={clearFlagAndClose}
                >
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FaciliterCredentialsVerificationModal;
